var _style, _path, _path2, _polygon, _path3, _polygon2, _polygon3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "859.2px",
    height: "251.1px",
    viewBox: "0 0 859.2 251.1",
    style: {
      enableBackground: "new 0 0 859.2 251.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{fill:url(#SVGID_9_);}\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#0F1212;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.3789,
    y1: 238.5321,
    x2: 203.3176,
    y2: 45.8386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C08B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DCE9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M89.8,221.7c0,0,19-10.2,40.2-8.2c21.2,2,41.9,6.3,53.3,6.3c11.4,0,36.1-2.2,47.2-16.4c0,0-16.1,7.4-37.3,6.7 c-8.9-0.3-17.8-1.5-26.5-3.1c-18.8-3.4-37.6-6.6-55.9,0.9C102.9,211.2,95.9,215.9,89.8,221.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.2689,
    y1: 240.3177,
    x2: 210.2075,
    y2: 47.6247
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C08B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DCE9"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.1,246.1c0,0,10.8-5.8,22.9-4.7c12.1,1.1,23.9,3.6,30.3,3.6s20.5-1.2,26.9-9.3c0,0-9.2,4.2-21.2,3.8 c-5.1-0.2-10.1-0.9-15.1-1.8c-10.7-1.9-21.4-3.8-31.8,0.5C127.6,240.2,123.5,242.9,120.1,246.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.4316,
    y1: 239.584,
    x2: 207.3708,
    y2: 46.8888
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C08B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DCE9"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "191.3,61 192.4,63.1 212.9,73.4 207.7,66.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.9546,
    y1: 247.2338,
    x2: 236.8934,
    y2: 54.54
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C08B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DCE9"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M253.9,99.4l-14-7.3v0l-4.1-7.5l30.1,13.1l-1.1-3.5l-34.3-17.4c0,0-17.4-25.3-19.1-27.4 c-1.1-1.4-3-2.2-4.6-2.7c-2.3-0.7-4.5-0.5-6.7,0.4c-0.5,0.2-0.9,0.5-1.3,0.9c-2.2,2.5,0,6.1,1.9,8.6c0.4,0.6,0.9,1.1,1.2,1.5 c2,2.5,4,4.9,6,7.4c2.7,3.3,5.3,6.5,8,9.8c2.2,2.7,4.4,5.4,6.7,8c0.5,0.6,1.1,1.3,1.7,1.9c3.1,3.4,11.6,11.4,16,8.9l14.1,6.9 L253.9,99.4z M206.9,48.4c0,0,4.2,1.9,5.4,6.2L206.9,48.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.4452,
    y1: 250.9895,
    x2: 251.3841,
    y2: 58.2954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C08B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DCE9"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "249.1,80.3 247.9,78.8 241.8,81.8 246.2,84  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.7619,
    y1: 250.0372,
    x2: 247.7014,
    y2: 57.3406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C08B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DCE9"
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "241.3,88.7 238.3,87 240.2,90.6  "
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 63.6018,
    y1: 215.2654,
    x2: 113.5407,
    y2: 22.5713
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C08B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DCE9"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M44.6,71.1C59,59.6,80.3,58,91.1,58c-29-7.3-54.7,3.9-55,4.1l3.6-6L0,72.9c5.4-9.3,12.8-16,19.9-20.7 c4.6-3.3,10.5-6.5,18.5-9.2c3.7-1.3,6.1-1.8,6.1-1.8v0c1.4-0.4,2.9-0.7,4.5-1.1c25.2-5.4,38.7,6.3,44.6,13.9 c-1.2-30,10.3-46.9,10.3-46.9c-4.4,14.6-5.1,30.7-5,41.1c3.5-8.3,11.6-18.6,30.1-22.4c1.4-0.3,2.8-0.5,4.1-0.8v0 c0,0,2.1-0.5,5.7-0.7c7.6-0.7,13.6-0.3,18.7,0.9c7.7,1.4,16.2,4.3,24,9.9l-39,0.5l5.2,3.7c0,0-26.5-0.1-48.2,17.5 c7.6-4.3,30.1-15.5,50.6-11.2c25,5.2,48.3,35.7,48.7,36.1l-32.5-20.3l1.5,7c0,0-0.7-0.6-0.7-0.6c-13.8-11.9-34.5-13.4-49.8-12.4 c0.4,0.1,0.9,0.2,1.3,0.3c2.3,0.5,4.5,1.3,6.6,2.3c1.5,0.7,3.1,1.6,4.5,2.5c0.7,0.5,1.5,0.9,2.2,1.4c0.6,0.4,1.2,0.8,1.7,1.3 c0.7,0.5,1.4,1.1,2.1,1.7c0.8,0.7,1.6,1.4,2.4,2.1c0.9,0.8,1.7,1.7,2.5,2.6c0.9,1,1.8,2,2.6,3c0.9,1.1,1.8,2.3,2.6,3.5 c0.9,1.3,1.7,2.6,2.5,4c0.8,1.5,1.6,3,2.3,4.5c0.8,1.6,1.4,3.3,2,5c0.6,1.8,1.2,3.7,1.6,5.5c0.5,2,0.9,4,1.2,6.1 c0.3,2.2,0.5,4.4,0.6,6.6c0.1,2.4,0.1,4.8-0.1,7.2l-18.1-30.3l-0.9,5.2c0,0-12.2-21.2-36.3-30.4c0.3,12,4.1,65.8,44,104.8 c4,3.9,9.2,6.3,14.7,7c3.5,0.4,7,1,10.5,1.7c-1.7,1.6-3.5,3.1-5.5,4.5c-6.4,4.5-13.1,7.1-19.7,7.8c-2.6,0.3-5.1,0.3-7.6,0 c-1.6-0.2-3.2-0.5-4.7-0.9c-2.3-0.6-4.5-1.5-6.6-2.2c-1.8-0.7-3.8-1.4-5.7-2c-1.8-0.6-4.6-1.3-8-1.6c3.6-1.7,7.4-3.2,11.5-4.5 c2-0.6,2.8-2.9,1.7-4.7c-13.3-20.5-30.2-56.3-31.2-106.8c-16.1,18.9-17.3,42.1-17.3,42.1l-3.2-4.2l-2.4,35.2 c-1.2-2.1-2.3-4.2-3.3-6.3c-0.9-2-1.8-4.1-2.5-6.1c-0.7-1.9-1.3-3.9-1.7-5.9c-0.4-1.9-0.8-3.8-1.1-5.7c-0.2-1.8-0.4-3.6-0.5-5.4 c-0.1-1.7-0.1-3.4,0-5.1c0.1-1.6,0.2-3.1,0.4-4.7c0.2-1.4,0.4-2.9,0.7-4.3c0.3-1.3,0.6-2.6,0.9-3.9c0.3-1.2,0.7-2.3,1.1-3.5 c0.4-1,0.7-2,1.1-3c0.3-0.8,0.7-1.7,1.1-2.5c0.3-0.6,0.6-1.3,1-1.9c0.4-0.8,0.8-1.5,1.3-2.3c0.9-1.5,1.9-2.9,2.9-4.3 c1.4-1.8,3-3.5,4.8-5c0.5-0.4,0.9-0.8,1.4-1.1c-14.2,6.1-32.1,16.8-39,33.8c0,0-0.3,0.8-0.3,0.8l-1.9-6.9l-19.7,32.8 C17.7,124.9,24.7,87.1,44.6,71.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.1391,
    y1: 239.5066,
    x2: 207.0778,
    y2: 46.8134
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C08B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DCE9"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M106.2,235c0,0,14.5-7.8,30.8-6.3c16.2,1.5,32.1,4.9,40.8,4.9c8.7,0,27.6-1.7,36.2-12.5 c0,0-12.4,5.7-28.5,5.2c-6.8-0.2-13.6-1.2-20.3-2.4c-14.4-2.6-28.8-5.1-42.8,0.7C116.3,227,110.9,230.6,106.2,235z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.1278,
    y1: 237.9486,
    x2: 201.0663,
    y2: 45.2556
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C08B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00DCE9"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M214.4,126.5c0.2,0.2,0.4,0.5,0.7,0.7c0.8,0.9,1.6,1.9,2.2,3c0.5,0.8,0.9,1.6,1.3,2.5 c0.2,0.4,0.4,0.9,0.5,1.3c0.1,0.4,0.3,0.7,0.4,1.1c0.2,0.5,0.3,0.9,0.4,1.4c0.2,0.6,0.3,1.1,0.4,1.7c0.1,0.6,0.2,1.3,0.3,1.9 c0.1,0.7,0.2,1.4,0.2,2.2c0.1,0.8,0.1,1.6,0.1,2.4c0,0.9,0,1.7-0.1,2.6c-0.1,0.9-0.2,1.8-0.4,2.7c-0.2,1-0.4,1.9-0.6,2.8 c-0.3,1-0.6,2-1,3c-0.4,1-0.8,2.1-1.3,3.1c-0.5,1.1-1.1,2.1-1.8,3.1c-0.7,1.1-1.4,2.2-2.2,3.2l1.2-19l-2,2c0,0,1-12.5-6.3-23.8 c-3.7,24.9-13.9,42.2-22.1,52.6c28.3,8.1,52.9,21.2,52.9,21.2l-82.7,1.4c-6.1-0.9-12.4-1.5-18.8-1.5c-6.7,0-12.9,0.7-18.7,2.2 l-34.7,0.6c0,0,6.7-8.1,18.6-15.9c3.2-2.1,7-3,10.8-2.6c3,0.3,5.4,1,7,1.4c1.9,0.6,3.7,1.3,5.5,1.9c2.2,0.8,4.5,1.7,6.9,2.3 c3,0.8,6,1.3,9.1,1.3c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.7,0c8.3-0.2,16.8-3.1,24.7-8.7c0.2-0.1,0.4-0.3,0.5-0.4 c2.9-2.1,5.4-4.6,8.1-7c1.1-1,2.2-1.9,3.3-2.9c1.1-1,2.1-2.1,3.2-3.2c2-2.1,3.8-4.3,5.5-6.6c1.6-2.2,3.1-4.4,4.5-6.7 c1.3-2.2,2.5-4.4,3.6-6.7c1-2.1,2-4.2,2.8-6.4c0.8-1.9,1.5-3.9,2.1-5.9c0.5-1.7,1.1-3.4,1.5-5.1c0.4-1.4,0.7-2.8,1-4.2 c0.2-1.1,0.5-2.3,0.6-3.4c-6.8,1.6-12.2,5.1-15.9,8.1c-3.7,3-5.7,5.7-5.7,5.7l-0.1-2.9l-11.8,15c0.1-1.3,0.2-2.6,0.5-3.8 c0.2-1.2,0.5-2.3,0.8-3.5c0.3-1.1,0.6-2.1,1-3.2c0.4-1,0.8-1.9,1.3-2.8c0.4-0.9,0.9-1.7,1.4-2.5c0.5-0.8,1-1.5,1.5-2.3 c0.5-0.7,1.1-1.3,1.6-2c0.5-0.6,1.1-1.2,1.6-1.7c0.5-0.5,1.1-1,1.6-1.4c0.5-0.4,1-0.8,1.5-1.2c0.5-0.3,0.9-0.7,1.4-1 c0.4-0.3,0.8-0.5,1.3-0.8c0.3-0.2,0.7-0.4,1-0.6c0.4-0.2,0.8-0.4,1.3-0.6c0.9-0.4,1.7-0.7,2.6-1c1.2-0.4,2.4-0.6,3.7-0.8 c0.2,0,0.5,0,0.7-0.1c-8.2-1.6-19.4-2.3-27.6,3.2c0,0-0.4,0.3-0.4,0.3l1.3-3.7l-18.8,8.6c0.2-0.2,14.9-14.9,28.7-16 c11.3-0.8,22.6,6.7,26.4,9.6c-10.4-11-24.7-12.8-24.7-12.8l3-1.6l-20.9-3c4.6-2.5,9.4-3.5,13.6-3.7c2.8-0.2,6-0.1,10.1,0.9 c0.9,0.2,1.7,0.4,2.2,0.5c0.5,0.2,0.8,0.2,0.8,0.2c0.7,0.2,1.4,0.4,2.1,0.7c9.7,3.3,13.3,9.4,14.6,14.1c0.8-5.5,1.5-14.2,0.2-22.4 c0.2,0.5,4.9,10.3,2.2,25.9c3.7-3.7,11.8-9,24.9-4.3c0.8,0.3,1.6,0.6,2.3,0.9c0,0,1.2,0.4,3.1,1.4c4.1,2,7.1,4.1,9.3,6.2 c3.5,3.1,7,7.2,9.2,12.5l-20.1-11.8l1.5,3.5c-0.4-0.2-13.3-7.9-29.2-6c5.8,0.7,17.1,3.1,24,10.3c9.6,10,10.6,30.7,10.7,31.1 l-8.3-19l-1.5,3.6c0,0-0.1-0.5-0.1-0.5C230.5,137.8,221.6,130.8,214.4,126.5z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "truant",
    className: "st9",
    d: "M355.2,84.6h-66.2v9.2h27.5v76.4h11.2V93.8h27.5L355.2,84.6L355.2,84.6z M442,170.2h12.1v-0.7 L434,133.2c4.8-1.7,9-4.8,12-8.9c2.9-4,4.4-8.9,4.3-13.9c0.5-7.2-2.4-14.3-7.8-19.2c-5.2-4.4-12.6-6.6-22.3-6.6h-28.4v85.6h11.4 v-34.6h20.1L442,170.2z M403.3,93.8h17.3c4.9-0.3,9.8,1.2,13.7,4.3c3.3,3.2,5,7.6,4.7,12.2c0.2,4.4-1.6,8.7-5,11.6 c-3.8,3.1-8.5,4.6-13.4,4.4h-17.4L403.3,93.8L403.3,93.8z M539.2,84.6v58.1c0.3,5.3-1.5,10.5-5.1,14.4c-8.6,6.8-20.7,6.8-29.3,0 c-3.6-3.9-5.4-9.1-5.1-14.4v-58h-11.2v58.3c-0.3,7.9,2.8,15.5,8.5,20.9c6.2,5.3,14.3,8,22.4,7.6l3-0.1c7.7-0.2,15-3.3,20.5-8.7 c5.1-5.3,7.9-12.5,7.6-19.8V84.6H539.2L539.2,84.6z M646.7,170.2h11.6l-32.8-85.6h-9.9l-32.7,85.6h11.7l8.1-22.4h35.9L646.7,170.2z  M620.5,98.5l14.6,40.1H606L620.5,98.5z M759.7,84.6h-11.2v66.3l-43.2-66.3h-11.4v85.6h11.4v-66l43.1,66h11.3L759.7,84.6L759.7,84.6 z M861.4,84.6h-66.3v9.2h27.5v76.4h11.2V93.8h27.5V84.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg06);
export default __webpack_public_path__ + "static/media/06.dc9576c06d7cd2c0ac914888bc00125b.svg";
export { ForwardRef as ReactComponent };